// extracted by mini-css-extract-plugin
module.exports = {"footerStyle":"styles_footerStyle__1ySGR"};